import { Outlet } from 'react-router'

import { TitleSetter } from '@/components/Title'

export const ImportEventsView = () => {
  return (
    <>
      <TitleSetter title="Import Events" />

      <Outlet />
    </>
  )
}
